// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"315":"ucare-panel-chunk","923":"ucare-widget-chunk"}[chunkId] || chunkId) + "." + {"46":"f65cbe7c","315":"129f9c55","787":"fc7fcb3f","923":"58c9d813"}[chunkId] + ".chunk.js";
};